// extracted by mini-css-extract-plugin
module.exports = {"slider-nav":"SlidevNavCircle_slider-nav__jWBKJ","bi-chevron-right":"SlidevNavCircle_bi-chevron-right__8spo5"};